import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonTable from "../common-components/common-tables/CommonTable";
import { formatDateTime } from "../common-data/Converts";
import {
  PersonIcon,
  CallIcon,
  CalendarIcon,
  EmailIcon,
  EyeIcon,
} from "../../images/icons/icons";

const WTF360ConsultationsListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const {
    wtf360ConsultationsLoading,
    wtf360ConsultationsError,
    wtf360Consultations,
  } = useSelector((state) => state.prospects);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (
      !wtf360ConsultationsLoading &&
      !wtf360ConsultationsError &&
      wtf360Consultations?.status &&
      wtf360Consultations?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: wtf360Consultations.data,
        pagination:
          wtf360Consultations?.pagination?.length > 0
            ? wtf360Consultations.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [
    wtf360ConsultationsLoading,
    wtf360ConsultationsError,
    wtf360Consultations,
  ]);

  const tbColumns = [
    {
      dataField: "full_name",
      text: "Customer Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.full_name || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.phone_number || "NA"}</span>
            </div>

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row?.email}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "primary_goal",
      text: "Primary Goal",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.primary_goal?.replace(/_/g, " ")}
          </span>
        );
      },
    },
    {
      dataField: "preferred_city",
      text: "Preferred City",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.preferred_city || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const status = row?.status?.toLowerCase();
        const statusMap =
          status === "pending"
            ? "tb-badge-success-2"
            : status === "contacted"
            ? "tb-badge-success-1"
            : status === "scheduled"
            ? "tb-badge-success"
            : status === "completed"
            ? "tb-badge-success"
            : status === "cancelled"
            ? "not-assigned"
            : "tb-badge";
        return (
          <span className={`tb-data tb-badge ${statusMap}`}>{status}</span>
        );
      },
    },
    {
      dataField: "notes",
      text: "Notes",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data tb-link"
            onClick={() =>
              setModValues({
                isModOpen: true,
                modName: "notes",
                rowData: row,
              })
            }
          >
            read
          </span>
        );
      },
    },
    {
      dataField: "created_at",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <CalendarIcon color="#2c3e50" />
            </span>{" "}
            <span className="tb-data">
              {row?.created_at ? formatDateTime(row.created_at) : "-"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="view-details"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues({
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                })
              }
            >
              <EyeIcon />
              view
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="common-table-container">
      <CommonTable
        tableData={allDatas.allData}
        tablePagination={allDatas.pagination}
        tableColumns={tbColumns}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        isLoading={wtf360ConsultationsLoading}
      />
    </div>
  );
};

export default WTF360ConsultationsListings;
